var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.177,
    height: 15.639,
    viewBox: "0 0 12.177 15.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M.855,13.887V3.462H11.281V13.887a1.69,1.69,0,0,1-.509,1.242,1.643,1.643,0,0,1-1.2.509H2.606a1.69,1.69,0,0,1-1.242-.509A1.69,1.69,0,0,1,.855,13.887ZM12.177.855V2.606H0V.855H3.054L3.91,0H8.267l.855.855Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNode);
export default __webpack_public_path__ + "static/media/delete_node.0a255be2e3ecbd764bbbe4ef0fa518d2.svg";
export { ForwardRef as ReactComponent };